import { ElementRef, inject, Injectable } from '@angular/core';
import { Observable, of, take } from 'rxjs';
import { IAbstractPresenter, IconName, ILanguageObject } from '@core/interfaces';
import { IIconComponent, IIconPresenter } from './interfaces';
import { IconService } from '@/core/services';

@Injectable({ providedIn: 'root' })
export class IconPresenter extends IAbstractPresenter<IIconComponent> implements IIconPresenter {
	loading$: Observable<boolean> = of(false);
	translations: ILanguageObject = {};
	iconName: IconName | null = null;
	
	private _iconName: string = '';
	
	iconElement = inject(ElementRef<HTMLElement>);
	
	constructor(private iconService: IconService) {
		super();
	}

	override onInit(): void {
		this.setIconName();
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	getIconName(): string | null {
		return this.view?.iconName;
	}

	setIconName(): void {
		if (!this.view.iconName || this.view.iconName === this._iconName) return;

		this._iconName = this.view.iconName;

		this.iconService
			.getIcon(this.view.iconName as IconName)
			.pipe(take(1))
			.subscribe(icon => (this.iconElement.nativeElement.innerHTML = icon));
	}
}
